import { connect, useSelector } from "react-redux";
import { FormEvent, useEffect, useState } from "react";
import ConfirmationDialog from "components/delete/ConfirmationDialog";
import { MembershipDurationsProps } from "../../store/actionType";
import { deleteMembershipDuration } from "../../store/action";

interface CategoryProps {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
  membershipData: MembershipDurationsProps;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CategoryProps;
const HandleDeleteMembersgipDuration:React.FC<Props> = ({
     closeModal,
  membershipData,
  onDeleteMembership,
}) =>{
    const [error,setError] = useState("")
    const [submitted, setSubmitted] = useState(false);
   const membershipState = useSelector(
    (state: any) =>  state.membershipDuration?.genericMembershipDurationState
  );
  
  const handleDeletePackage = async (e: FormEvent) => {
    e.preventDefault();
    onDeleteMembership(membershipData.id.toString());
    setSubmitted(true)
  };
   useEffect(() => {
  if (!membershipState.isLoading && submitted) {
    if (membershipState.status === "SUCCESS") {
      closeModal(false);
      setError("");
      setSubmitted(false);
    }
    if (membershipState.status === "FAILED") {
      setError(membershipState.delete); 
    }
  }
}, [membershipState.isLoading, membershipState.status, submitted]);

    return(
        <>
      <ConfirmationDialog
        title={`Delete ${membershipData.duration_type}`}
        message={"Are you sure you want to delete this membership duration?"}
        onConfirm={handleDeletePackage}
        onCancel={closeModal}
        error={error}
      />
    </>
    )
};
const mapDispatchToProps = (dispatch: any) => ({
  onDeleteMembership: (duration_id: string) => dispatch(deleteMembershipDuration(duration_id)),
});

export default connect(null, mapDispatchToProps)(HandleDeleteMembersgipDuration);